import React from 'react';
import { motion } from 'framer-motion';
import { experience } from '../../data/portfolioData';
import CardSpotlight from '../CardSpotlight/CardSpotlight';
import styles from './Experience.module.css';

const fadeUpVariants = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } }
};

const slideInLeftVariants = {
  hidden: { opacity: 0, x: -40 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.5, ease: "easeOut" } }
};

const staggerContainer = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.15 } }
};

const Experience = () => {
  return (
    <section id="experience" className={styles.experienceSection}>
      <div className={styles.container}>
        <motion.div 
          className={styles.header}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={fadeUpVariants}
        >
          <span className={styles.label}>CAREER</span>
          <h2 className={styles.h2}>Work Experience</h2>
        </motion.div>

        <motion.div 
          className={styles.timeline}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.1 }}
          variants={staggerContainer}
        >
          {experience.map((job, index) => (
            <motion.div key={index} variants={slideInLeftVariants} className={styles.timelineItem}>
              <div className={styles.timelineDot}></div>
              <CardSpotlight className={styles.timelineCard}>
                <div className={styles.cardHeader}>
                  <h3 className={styles.company}>{job.company}</h3>
                  <span className={styles.date}>{job.date}</span>
                </div>
                <div className={styles.role}>{job.role}</div>
                <div className={styles.location}>{job.location}</div>
                <ul className={styles.points}>
                  {job.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
              </CardSpotlight>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Experience;
